
import { RoutePermittedRole } from "shared/constants/AppConst";
import Contact from "./contact_page";
import { isModuleAuthorized } from "@crema/utility/Utils";
import Error403 from "pages/errorPages/Error403";

export const contactMasterConfig = [
  {
    permittedRole: RoutePermittedRole.User,
    path: "/contactUs",
    exact: true,
    element: isModuleAuthorized("Manage Contact Us") ? <Contact /> : <Error403 />,
  }
];


